var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186.1,
    height: 23.375,
    viewBox: "0 0 186.1 23.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-footer",
    transform: "translate(-411.059 -1271.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4986",
    "data-name": "Grupo 4986",
    transform: "translate(459.818 1274.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4985",
    "data-name": "Grupo 4985",
    transform: "translate(83.72 4.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4983",
    "data-name": "Grupo 4983",
    transform: "translate(7.694 7.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25780",
    "data-name": "Trazado 25780",
    d: "M1160.478,1353.035s0,.019,0,.053v-.053Z",
    transform: "translate(-1159.977 -1353.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25781",
    "data-name": "Trazado 25781",
    d: "M1157.82,1359.609c.03-.036.058-.072.084-.108Q1157.864,1359.556,1157.82,1359.609Z",
    transform: "translate(-1157.82 -1358.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25782",
    "data-name": "Trazado 25782",
    d: "M1159.074,1357.72l-.023.051c-.009.019-.021.038-.032.057C1159.04,1357.792,1159.057,1357.756,1159.074,1357.72Z",
    transform: "translate(-1158.794 -1356.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25783",
    "data-name": "Trazado 25783",
    d: "M1159.35,1357.248c-.007.019-.015.038-.023.055l-.017.034C1159.325,1357.306,1159.338,1357.276,1159.35,1357.248Z",
    transform: "translate(-1159.03 -1356.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25784",
    "data-name": "Trazado 25784",
    d: "M1159.634,1356.6a.077.077,0,0,1-.006.019.6.6,0,0,1-.026.064C1159.613,1356.659,1159.625,1356.631,1159.634,1356.6Z",
    transform: "translate(-1159.267 -1355.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25785",
    "data-name": "Trazado 25785",
    d: "M1159.8,1356.182c-.006.023-.013.045-.021.068,0,0,0,.007-.006.011C1159.782,1356.235,1159.792,1356.208,1159.8,1356.182Z",
    transform: "translate(-1159.406 -1355.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25786",
    "data-name": "Trazado 25786",
    d: "M1160.145,1354.282v.007c0,.011,0,.023-.006.036s-.011.055-.017.085-.008.036-.013.055-.01.04-.015.058C1160.117,1354.433,1160.134,1354.352,1160.145,1354.282Z",
    transform: "translate(-1159.667 -1354.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25787",
    "data-name": "Trazado 25787",
    d: "M1160.383,1353.558a.176.176,0,0,1,0,.03c0,.024-.006.051-.01.079l-.006.023c.006-.047.011-.089.015-.123C1160.383,1353.566,1160.383,1353.562,1160.383,1353.558Z",
    transform: "translate(-1159.888 -1353.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25788",
    "data-name": "Trazado 25788",
    d: "M1160.47,1353.035s0,.019,0,.053a.078.078,0,0,1,0,.019c0-.045,0-.072,0-.072Z",
    transform: "translate(-1159.969 -1353.035)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4984",
    "data-name": "Grupo 4984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25789",
    "data-name": "Trazado 25789",
    d: "M1128.167,1311.558v7.786c0,.021,0,.042,0,.06a.224.224,0,0,1,0,.036,4.45,4.45,0,0,1-1.468,3.444l-.013.013a4.7,4.7,0,0,1-1.661,1.07,6.9,6.9,0,0,1-2.493.425h-.03l-.055,0a.123.123,0,0,0,.025,0,6.9,6.9,0,0,1-2.493-.425,4.7,4.7,0,0,1-1.661-1.07.046.046,0,0,1-.013-.013,4.458,4.458,0,0,1-1.468-3.412c0-.015,0-.028,0-.042,0-.057,0-.087,0-.087v-7.786h3.146v7.786h0s0,.019,0,.053a.084.084,0,0,0,0,.019.078.078,0,0,1,0,.022v0a.223.223,0,0,0,0,.03c0,.024.006.051.01.079l.006.034c0,.011,0,.023.006.036s.012.056.017.085.009.036.013.055.009.04.015.058a.985.985,0,0,0,.034.115c.006.023.013.045.021.068l.006.011c0,.006,0,.013.006.019.007.021.017.043.026.064,0,0,0,0,0,.006a.113.113,0,0,0,.006.015c.008.023.019.047.03.072l.017.034.023.051c.011.019.021.038.032.057s.032.058.051.089a.183.183,0,0,1,.011.021.159.159,0,0,1,.011.019.067.067,0,0,1,.01.013.864.864,0,0,0,.051.075.037.037,0,0,1,.008.009,1.322,1.322,0,0,0,.083.108,0,0,0,0,0,0,0c0,.006.006.008.009.013s.01.009.013.015l.015.015c.025.028.049.056.077.085a3.045,3.045,0,0,0,3.817,0c.042-.043.081-.087.117-.13a1.35,1.35,0,0,0,.083-.108.031.031,0,0,0,.007-.009.65.65,0,0,0,.051-.075.082.082,0,0,0,.009-.013.132.132,0,0,1,.012-.019.082.082,0,0,0,.011-.021.876.876,0,0,0,.051-.089c.011-.019.022-.038.032-.057l.023-.051.017-.034a.713.713,0,0,0,.03-.072.029.029,0,0,0,.006-.015s0,0,0-.006a.54.54,0,0,0,.026-.064.074.074,0,0,0,.006-.019s0-.007.006-.011c.008-.023.015-.045.021-.068a.963.963,0,0,0,.034-.115c.006-.019.011-.04.015-.058s.009-.038.013-.055.011-.058.017-.085,0-.025.006-.036l.006-.034c0-.028.006-.055.009-.079a.193.193,0,0,0,0-.03v0a.087.087,0,0,0,0-.022.074.074,0,0,0,0-.019c0-.034,0-.053,0-.053h0v-7.786Z",
    transform: "translate(-1116.828 -1311.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25790",
    "data-name": "Trazado 25790",
    d: "M1133.612,1353.567v.021a.188.188,0,0,1,0-.03A.021.021,0,0,1,1133.612,1353.567Z",
    transform: "translate(-1130.46 -1345.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25791",
    "data-name": "Trazado 25791",
    d: "M1160.448,1353.558a.2.2,0,0,1,0,.03v-.021S1160.448,1353.562,1160.448,1353.558Z",
    transform: "translate(-1152.259 -1345.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25792",
    "data-name": "Trazado 25792",
    d: "M1133.581,1353.035v.053c0-.034,0-.053,0-.053Z",
    transform: "translate(-1130.435 -1345.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25793",
    "data-name": "Trazado 25793",
    d: "M1135.884,1359.609q-.044-.053-.084-.108C1135.826,1359.537,1135.854,1359.573,1135.884,1359.609Z",
    transform: "translate(-1132.239 -1350.502)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25794",
    "data-name": "Trazado 25794",
    d: "M1133.583,1353.107a.073.073,0,0,1,0-.019c0-.034,0-.053,0-.053h0S1133.581,1353.062,1133.583,1353.107Z",
    transform: "translate(-1130.435 -1345.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25795",
    "data-name": "Trazado 25795",
    d: "M1133.627,1353.69l-.006-.023c0-.028-.006-.055-.01-.079a.188.188,0,0,1,0-.03.021.021,0,0,1,0,.009C1133.616,1353.6,1133.621,1353.643,1133.627,1353.69Z",
    transform: "translate(-1130.46 -1345.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25796",
    "data-name": "Trazado 25796",
    d: "M1133.751,1354.523c-.006-.019-.011-.04-.015-.058s-.008-.036-.013-.055-.011-.059-.017-.085,0-.025-.006-.036v-.007C1133.711,1354.352,1133.728,1354.433,1133.751,1354.523Z",
    transform: "translate(-1130.533 -1346.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25797",
    "data-name": "Trazado 25797",
    d: "M1134.178,1356.261l-.006-.011c-.008-.023-.015-.045-.021-.068C1134.16,1356.208,1134.169,1356.235,1134.178,1356.261Z",
    transform: "translate(-1130.9 -1347.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25798",
    "data-name": "Trazado 25798",
    d: "M1134.325,1356.687c-.009-.021-.019-.043-.026-.064,0-.006,0-.013-.006-.019C1134.3,1356.631,1134.314,1356.659,1134.325,1356.687Z",
    transform: "translate(-1131.015 -1348.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25799",
    "data-name": "Trazado 25799",
    d: "M1134.585,1357.337l-.017-.034c-.008-.017-.015-.036-.023-.055C1134.556,1357.276,1134.569,1357.306,1134.585,1357.337Z",
    transform: "translate(-1131.219 -1348.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25800",
    "data-name": "Trazado 25800",
    d: "M1134.811,1357.828c-.011-.019-.021-.038-.032-.057l-.023-.051C1134.773,1357.756,1134.79,1357.792,1134.811,1357.828Z",
    transform: "translate(-1131.391 -1349.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25801",
    "data-name": "Trazado 25801",
    d: "M1146.9,1379.929h0Z",
    transform: "translate(-1141.23 -1367.095)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25802",
    "data-name": "Trazado 25802",
    d: "M967.96,1308.231c-7.019,2.323-6.983-3.775-6.983-3.775v-11.749l3.145-.425v3.618h3.405v2.76h-3.405v5.548c0,2.749,3.047,1.427,3.047,1.427Z",
    transform: "translate(-906.512 -1291.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4258",
    "data-name": "Rect\\xE1ngulo 4258",
    width: 3.146,
    height: 12.67,
    transform: "translate(10.505 4.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25803",
    "data-name": "Trazado 25803",
    d: "M1309.8,1349.474c.008-.035.015-.07.022-.105-.007.036-.014.073-.022.108Z",
    transform: "translate(-1189.86 -1337.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25804",
    "data-name": "Trazado 25804",
    d: "M1309.824,1340.791c-.007-.035-.014-.07-.022-.1v0C1309.81,1340.72,1309.817,1340.756,1309.824,1340.791Z",
    transform: "translate(-1189.86 -1330.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25805",
    "data-name": "Trazado 25805",
    d: "M1006.813,1310.729h-2.768v12.67h3.146v-6.993a2.722,2.722,0,0,1,2.705-2.913s2.422-.122,2.454,3.2v6.709h3.146v-7.181a2.757,2.757,0,0,1,2.784-2.729c2.291,0,2.265,2.9,2.265,2.9v7.007h3.051v-7.085s.267-5.772-5.348-5.772a4.829,4.829,0,0,0-4.074,2.343,4.084,4.084,0,0,0-3.586-2.346,3.662,3.662,0,0,0-3.4,1.685Z",
    transform: "translate(-941.496 -1306.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25806",
    "data-name": "Trazado 25806",
    d: "M1197.321,1316.219v7.181h-3.146v-6.709c-.031-3.318-2.454-3.2-2.454-3.2a2.722,2.722,0,0,0-2.7,2.914v6.992h-3.146v-12.67h2.768l.378,1.494a3.661,3.661,0,0,1,3.4-1.685S1197.321,1310.572,1197.321,1316.219Z",
    transform: "translate(-1089.192 -1306.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25807",
    "data-name": "Trazado 25807",
    d: "M831.542,1300.621l5.067-4.724h-3.774l-4.577,4.275v-7.889l-3.145.425v15.864h3.145v-4.9h.011l1.044-.973,4.313,5.808H837.4Z",
    transform: "translate(-796.151 -1291.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25808",
    "data-name": "Trazado 25808",
    d: "M889.984,1310.553a6.182,6.182,0,0,0-6.664,6.37s-.177,6.7,6.729,6.653a7.694,7.694,0,0,0,5.507-1.933l-1.859-1.878s-5.332,3.356-7.2-1.615h9.9S897.141,1310.553,889.984,1310.553Zm-3.4,5.049a3.5,3.5,0,0,1,3.492-2.376,3.163,3.163,0,0,1,3.32,2.376Z",
    transform: "translate(-843.431 -1306.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1803",
    "data-name": "Elipse 1803",
    cx: 1.746,
    cy: 1.746,
    r: 1.746,
    transform: "translate(10.332 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25809",
    "data-name": "Trazado 25809",
    d: "M1264.693,1292.708v4.906a5.828,5.828,0,0,0-4.346-1.992,6.638,6.638,0,0,0,0,13.228,5.827,5.827,0,0,0,4.346-1.993l.377,1.714h2.767v-16.288Zm-3.65,13.41a3.882,3.882,0,1,1,3.65-4.749c.008.036.015.072.022.107s.012.063.017.094.01.062.015.094.005.033.007.051.005.04.007.06,0,.031.005.047,0,.03,0,.044,0,.037.005.057,0,.042,0,.063c0,.047.006.094.007.141s0,.074,0,.111,0,.074,0,.111,0,.094-.007.14c0,.022,0,.043,0,.065s0,.032,0,.049,0,.04-.006.06,0,.02,0,.029c0,.025-.006.051-.01.076s0,.023,0,.034c0,.029-.008.058-.013.087a.007.007,0,0,1,0,.005c-.005.035-.011.07-.018.1s-.014.073-.022.108A3.778,3.778,0,0,1,1261.043,1306.117Z",
    transform: "translate(-1144.751 -1291.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25810",
    "data-name": "Trazado 25810",
    d: "M1339.631,1310.553a6.512,6.512,0,1,0,6.511,6.511A6.512,6.512,0,0,0,1339.631,1310.553Zm0,10.075a3.563,3.563,0,1,1,3.564-3.563A3.563,3.563,0,0,1,1339.631,1320.628Z",
    transform: "translate(-1208.8 -1306.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25811",
    "data-name": "Trazado 25811",
    d: "M757.843,1320.628a3.563,3.563,0,1,1,2.974-5.525l2.893-.868a6.511,6.511,0,1,0,0,5.658l-2.893-.868A3.555,3.555,0,0,1,757.843,1320.628Z",
    transform: "translate(-736.218 -1306.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25812",
    "data-name": "Trazado 25812",
    d: "M680.081,1308.1c-7.019,2.323-6.983-3.775-6.983-3.775v-5.8h-2.281v-2.76H673.1v-3.193l3.145-.425v3.618h3.4v2.76h-3.4v5.548c0,2.748,3.047,1.427,3.047,1.427Z",
    transform: "translate(-670.817 -1291.179)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25813",
    "data-name": "Trazado 25813",
    d: "M498.8,1296.549c-3.82,6.962-6.639,7.645-7.06,7.711a2.957,2.957,0,0,1-1.171-.323,11.274,11.274,0,0,1-3.839-4.159q-.349-.6-.68-1.156c-.006-.008-.009-.015-.015-.024-.957-1.62-1.808-3.018-2.562-4.225-.015-.024-.03-.047-.043-.07,3.9-6.958,6.75-7.552,7.108-7.6h0a2.943,2.943,0,0,1,1.19.325,11.271,11.271,0,0,1,3.839,4.158c.233.4.458.783.679,1.156a.185.185,0,0,1,.015.026C497.214,1293.966,498.055,1295.352,498.8,1296.549Z",
    transform: "translate(-58.79 -12.357)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25814",
    "data-name": "Trazado 25814",
    d: "M547.763,1282.759c-.678,1.391-4.34,8.687-6.652,9.151h-13.7l.054-.006c.421-.066,3.24-.749,7.06-7.711a76.611,76.611,0,0,0,5.26-12.586.169.169,0,0,1,.3-.045l3.157,4.445a4.631,4.631,0,0,0-.22,1.049c-.154,1.626.52,3.019,1.5,3.111a1.482,1.482,0,0,0,1.237-.61l1.965,2.769A.424.424,0,0,1,547.763,1282.759Z",
    transform: "translate(-94.514 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25815",
    "data-name": "Trazado 25815",
    d: "M431.79,1286.682a.264.264,0,0,0-.036,0h0c-.359.049-3.212.642-7.108,7.6a75.93,75.93,0,0,0-5.43,12.8.174.174,0,0,1-.306.047l-3.244-4.516a4.639,4.639,0,0,0,.229-1.072c.156-1.633-.527-3.033-1.53-3.127a1.517,1.517,0,0,0-1.265.625l-1.96-2.727a.426.426,0,0,1-.036-.437c.691-1.4,4.413-8.73,6.763-9.2Z",
    transform: "translate(0 -12.34)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.d9fa425af0782d4da9b037b80a2bc815.svg";
export { ForwardRef as ReactComponent };